function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-206.31 -93.173)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.76 -5.1174)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.33 -17.281)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.52 0h-11.919c-0.33184 0-0.60085 0.26902-0.60085 0.79104v21.798c0 0.1417 0.26901 0.4107 0.60085 0.4107h16.458c0.3319 0 0.6009-0.269 0.6009-0.4107v-17.259c0-0.28586-0.0382-0.37786-0.1055-0.44563l-4.7789-4.7791c-0.0678-0.067358-0.1598-0.10555-0.2555-0.10555z",
  fill: "#e9e9e0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.731 0.062012v4.8666h4.8664z",
  fill: "#d9d7ca"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.059 23h-16.458c-0.33184 0-0.60085-0.269-0.60085-0.6009v-6.3812h17.66v6.3812c0 0.3319-0.269 0.6009-0.6009 0.6009z",
  fill: "#ec6630"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m4.4997 17.629v4.1384h-0.67395v-1.8643h-1.7911v1.8643h-0.68504v-4.1384h0.68504v1.8137h1.7911v-1.8137z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.4636 17.629v0.4604h-1.235v3.678h-0.6793v-3.678h-1.2354v-0.4604z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.406 17.629h0.685v4.1384h-0.685v-2.8471l-0.9266 2.302h-0.5951l-0.93226-2.302v2.8471h-0.68504v-4.1384h0.68504l1.2297 2.8302z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.814 17.629v3.6274h1.9036v0.511h-2.5886v-4.1384z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m6.8616 6.6917c-0.16058-0.16059-0.42015-0.16059-0.58073 0l-2.4642 2.4643c-0.16059 0.16059-0.16059 0.42016 0 0.58075l2.4642 2.4643c0.08009 0.08 0.18523 0.1203 0.29037 0.1203 0.10513 0 0.21027-0.0403 0.29036-0.1203 0.16058-0.1606 0.16058-0.4202 0-0.5808l-2.1738-2.1739 2.1738-2.1739c0.16058-0.16059 0.16058-0.42016 0-0.58075z",
  fill: "#ec6630"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.254 9.156-2.4642-2.4643c-0.1606-0.16059-0.4201-0.16059-0.5807 0s-0.1606 0.42016 0 0.58075l2.1738 2.1739-2.1738 2.1739c-0.1606 0.1606-0.1606 0.4202 0 0.5808 0.0801 0.08 0.1852 0.1203 0.2904 0.1203 0.1051 0 0.2102-0.0403 0.2903-0.1203l2.4642-2.4643c0.1606-0.16059 0.1606-0.42016 0-0.58075z",
  fill: "#ec6630"
})))));

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.6725mm",
    height: "6.0855mm",
    viewBox: "0 0 4.6725 6.0855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.d1900d05.svg";
export { ForwardRef as ReactComponent };